export default "__VITE_ASSET__Mu2JInWW__"